export const useEditing = (controller) => {
  const controllerEdit = controller.edit?.bind(controller);
  const controllerSave = controller.save?.bind(controller);
  const controllerCancel = controller.cancel?.bind(controller);

  function edit(...args) {
    controller.element.classList.add("editing")

    if(controllerEdit) return controllerEdit(...args)
  }

  function cancel(...args) {
    controller.element.classList.remove("editing")

    if(controllerCancel) return controllerCancel(...args)
  }

  function save(...args) {
    controller.element.classList.remove("editing")

    if(controllerSave) return controllerSave(...args)
  }

  Object.assign(controller, { save, edit, cancel })
}
